module.exports = "<div class=\"sd-translation-line-skeleton\">\n</div>\n";